import './App.css';

function App() {
  return (
    <div className="App">
      <div className="privacy-policy-container">
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
          <h2>Balajee Durg Agency - Medical Orders App</h2>
          <p>Last Updated: August 23, 2025</p>
        </header>
        
        <main className="privacy-content">
          <section>
            <h3>1. Introduction</h3>
            <p>
              Welcome to the Medical Orders app ("the App") operated by Balajee Durg Agency ("we," "our," or "us"). 
              We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains 
              how we collect, use, disclose, and safeguard your information when you use our mobile application.
            </p>
            <p>
              Please read this Privacy Policy carefully. By accessing or using the App, you agree to the collection and use of 
              information in accordance with this policy.
            </p>
          </section>

          <section>
            <h3>2. Information We Collect</h3>
            <h4>2.1 Personal Information</h4>
            <p>
              We may collect personally identifiable information, such as:
            </p>
            <ul>
              <li>Name</li>
              <li>Contact information (email address, phone number)</li>
              <li>Medical information related to orders</li>
              <li>Prescription details</li>
              <li>Delivery address</li>
              <li>Payment information</li>
            </ul>

            <h4>2.2 Non-Personal Information</h4>
            <p>
              We may also collect non-personal information about how you use our App, including:
            </p>
            <ul>
              <li>Device information (model, operating system)</li>
              <li>Usage data (features accessed, time spent on App)</li>
              <li>Log data (IP address, browser type)</li>
            </ul>
          </section>

          <section>
            <h3>3. How We Use Your Information</h3>
            <p>We use the collected information for various purposes, including to:</p>
            <ul>
              <li>Process and fulfill medical orders</li>
              <li>Provide customer support</li>
              <li>Improve our App and services</li>
              <li>Send order updates and notifications</li>
              <li>Comply with legal obligations</li>
              <li>Prevent fraudulent activities</li>
            </ul>
          </section>

          <section>
            <h3>4. Data Security</h3>
            <p>
              We implement appropriate security measures to protect your personal information against unauthorized access, 
              alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic 
              storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h3>5. Data Sharing and Disclosure</h3>
            <p>We may share your information with:</p>
            <ul>
              <li>Healthcare providers to fulfill your orders</li>
              <li>Payment processors for transaction processing</li>
              <li>Delivery partners for order delivery</li>
              <li>Legal authorities when required by law</li>
            </ul>
            <p>
              We do not sell or rent your personal information to third parties for marketing purposes without your explicit consent.
            </p>
          </section>

          <section>
            <h3>6. Your Rights</h3>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Delete your personal information</li>
              <li>Object to processing of your information</li>
              <li>Withdraw consent at any time</li>
            </ul>
          </section>

          <section>
            <h3>7. Children's Privacy</h3>
            <p>
              Our App is not intended for children under 13 years of age. We do not knowingly collect personal information from 
              children under 13. If you are a parent or guardian and believe your child has provided us with personal information, 
              please contact us immediately.
            </p>
          </section>

          <section>
            <h3>8. Changes to This Privacy Policy</h3>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy 
              on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
            </p>
          </section>

          <section>
            <h3>9. Contact Us</h3>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <address>
              Balajee Durg Agency<br />
              Email: privacy@balajeedurg.com<br />
              Phone: +91-9708045117
            </address>
          </section>
        </main>
        
        <footer className="privacy-footer">
          <p>&copy; 2025 Balajee Durg Agency. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
